import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { StatAxis } from "./FriendsBoard";

// Стороны игры быстрого разбора. `Record` по union из контракта: новая сторона не соберётся
// без названия.
export const AXIS_LABELS: Record<StatAxis, MessageDescriptor> = {
  farm: msg`Farm`,
  aggression: msg`Aggression`,
  teamwork: msg`Teamwork`,
  survival: msg`Survival`,
};
